module.exports = __webpack_public_path__ + "static/media/talk03_medium@2x.126493cb.jpg";